/**
 * 放置交互相关的代码
 */
import { message } from "antd";
import { getUrlByObjectKey, getUrlByObjectKeyWithHit } from "@/api/freeDownload";
import { getServiceVal } from "@/utils/cookies";
import dataJson from "@/../public/data.json";
import { Resource } from "@/types/resource";
import {
	storageSaveDownload,
	storageGetDownload,
	storageRemoveDownload,
} from "@/utils/storage";
import {
	buildX86ImageDownloadSavePayload,
	resolveCurrentUserId,
	saveDeveloperX86ImageDownloadWithRetry,
	shouldReportDesktopDownloadAttraction,
	showX86DownloadQuotaModal,
} from "@/utils/desktopDownloadReport";
import {
	trackBaiduLegacyDownloadPath,
	trackBaiduPackageActionClick,
	type BaiduPackageActionPayload,
} from "@/utils/baiduStatTrack";

export type HandleBtnTrackMeta = Pick<
	BaiduPackageActionPayload,
	"tabCode" | "bizId" | "actionType" | "bizCode" | "channel"
>;


const { req_err } = dataJson;

const RESOURCE_MAP: any = {
  image_kaihong_stan_KHDVK_3568A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1.28/KHDVK-3568A/KaihongOS 5.0.1.28(MIPI).zip",
  image_kaihong_stan_KHD_3588A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1.28/KHD-3588A/KaihongOS 5.0.1.28.zip",
  tool_kaihong_stan_DevEco_Studio_v504:
    "kaihong/prod/default/private/freedownload/v1.2/tool/stan/DevEco Studio 5.0.4 Release/devecostudio-windows-5.0.11.110.zip",
  tool_kaihong_stan_DevEcoDeviceTool_v400:
    "kaihong/prod/default/private/freedownload/v1.2/tool/stan/KaihongOS 5.0.1/devicetool-windows-tool-4.0.0.400.zip",
  tool_kaihong_stan_HDC_v501:
    "kaihong/prod/default/private/freedownload/v1.2/tool/stan/KaihongOS 5.0.1/HDC.zip",
  tool_kaihong_stan_napi_generator_v501:
    "kaihong/prod/default/private/freedownload/v1.2/tool/stan/KaihongOS 5.0.1/napi-generator-0.0.vsix",
  doc_kaihong_stan_KHD_3568A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KHDVK-3568A/KaihongOS 5.0.1 Stan. 产品说明书 (KHDVK-3568A).pdf",
  doc_kaihong_stan_KHD_3588A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KHD-3588A/KaihongOS 5.0.1 Stan. 产品说明书 (KHD-3588A).pdf",
  doc_kaihong_stan_guJian_KHD_3568A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KHDVK-3568A/开鸿开发板 KHDVK-3568A 固件烧录指导书.pdf",
  doc_kaihong_stan_guJian_KHD_3588A_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KHD-3588A/开鸿开发板 KHD-3588A 固件烧录指导书.pdf",
  doc_kaihong_stan_north_app_dev_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. 北向应用开发指导书.pdf",
  doc_kaihong_stan_atomization_service_dev_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. 原子化服务开发指导书.pdf",
  doc_kaihong_stan_api_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. API参考.zip",
  doc_kaihong_stan_framework_dev_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. 框架开发指导书.pdf",
  doc_kaihong_stan_drive_dev_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. 驱动开发指导书.pdf",
  doc_kaihong_stan_se_linux_guide_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/stan/KaihongOS 5.0.1 Stan/KaihongOS 5.0.1 Stan. SELinux策略配置指导书.pdf",

  image_kaihong_desktop_rk_3588_v412:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/KaihongOS 4.1.2.74.001_debug.zip", //kaihongos stan. 桌面版 3588系统镜像 v4.1.2

  image_kaihong_desktop_rk_3588_v501:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/KaihongOS_5.0.1.41(KHP-LC802).zip", //kaihongos stan. 桌面版 3588系统镜像 v5.0.1.41

  image_kaihong_desktop_x86_v500:
    "MALL/resourceDownload/desktop_x86_trial/5.1/os_images/KaihongOS桌面版（x86）5.0试用版安装镜像包.zip",

  image_kaihong_desktop_x86_qemu_v500:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/KaihongOS桌面版（x86）5.0试用版QEMU镜像包.zip",
  
  image_kaihong_desktop_openclaw:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/openclaw-packages.zip", // KaihongOS桌面版小龙虾Arm64.0试用版
  
  image_kaihong_desktop_x86_verified:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/KaihongOS桌面版（x86）5.0开发者问题验证版镜像包.zip",

  image_kaihong_desktop_ai_tool_v1:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/BotBook AI本地工具开发包.zip", // AI部署工具包
  image_kaihong_desktop_DeepSeek_1_5B:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/BotBook deepseek1.5B本地部署.zip", // deepseek1.5B本地部署
  image_kaihong_desktop_DeepSeek_7B:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/BotBook deepseek7B本地部署.zip", // deepseek7B本地部署
  link_RKDevTool: "https://gitcode.com/open-source-toolkit/0d69c",
  tool_kaihong_desktop_HDC_v501:
    "kaihong/prod/default/private/freedownload/v1.2/tool/desktop/HDC.zip",
  tool_kaihong_desktop_ArkTS_plugin: "kaihong/prod/default/private/freedownload/v1.2/tool/desktop/kaihongos-devkit-5.0.1.35-linux-arm64.deb",
  tool_kaihong_desktop_Deveco_OHSDK_arm64:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/desktop/ohsdk-linux-arm64-11-14-18-20.tgz",
  doc_desktop_version_firmware_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 固件烧录指导说明书.pdf", // KaihongOS Stan.桌面版 - 指导书 - 固件烧录指导说明书 - BotBook
  doc_desktop_version_product_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 产品使用手册.pdf", // KaihongOS桌面版 - 指导书 - 产品使用手册
  doc_desktop_version_api_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 API参考.zip", // KaihongOS桌面版 - 指导书 - 操作系统的API接口
  doc_desktop_version_drive_development_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 驱动开发指导书.pdf", // KaihongOS桌面版 - 指导书 - 驱动开发指导书
  doc_desktop_version_license_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 License激活指导书.pdf", // KaihongOS桌面版  - 指导书 - License激活指导书
  doc_desktop_version_compile_guide_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 源码编译指导书.pdf", // KaihongOS桌面版 - 指导书 - 编译指导书
  doc_desktop_version_HiLog_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 HiLog命令行使用指导书.pdf", // KaihongOS桌面版 - 指导书 -  HiLog命令行使用指导书
  doc_desktop_version_north_application_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 北向应用开发指导书.pdf", // KaihongOS桌面版 - 指导书 - 北向应用开发指导书
  doc_desktop_version_south_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/南向课程文档pdf.zip", // KaihongOS桌面版 - 指导书 - 南向课程文档.zip
  doc_desktop_version_VSCode_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/VSCode插件使用指南（ArkTS Project Manager）.pdf", // KaihongOS桌面版 -  BotBook- VSCode插件使用指南（ArkTS Project Manager）
  doc_desktop_version_Ai_user_manual_BotBook:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/BotBook AI使用手册20250510.zip", //  KaihongOS桌面版 - 指导书 - BotBook AI使用手册20250510
  doc_desktop_version_ArkTS_Plugin:
    "kaihong/prod/default/private/freedownload/v1.2/document/desktop/KaihongOS桌面版 5.0.1 ArkTS插件使用指导.pdf", // KaihongOS Stan.桌面版 - 指导书 - KaihongOS桌面版 5.0.1 ArkTS插件使用指导

  image_kaihong_lite_release_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/lite/KaihongOS 5.0.1 Lite/KaihongOS 5.0.1.09 Lite/KaihongOS_5.0.1.09 Lite_release.bin",
  image_kaihong_lite_kKHDVK_ESP32:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/lite/KaihongOS_4.1.2.11(RT10E024C000M204)_release.bin", // KaihongOS Lite - KHDVK_ESP32 系统镜像
  image_kaihong_lite_khd_3863B:
    "kaihong/prod/default/private/freedownload/v1.2/os_images/lite/ws63-liteos-app_all.fwpkg", //kaihongos lite 3863B系统镜像
  link_tool_kaihong_lite_Flash:
    "https://www.espressif.com.cn/zh-hans/support/download/other-tools",
  link_tool_kaihong_lite_VisualStudioCode:
    "https://code.visualstudio.com/Download",
  doc_kaihong_lite_KHP_IC204_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/lite/KaihongOS 5.0.1 Lite/L0-IC204/KaihongOS 5.0.1 Lite 产品说明书 (KHP-IC204).pdf",
  doc_kaihong_lite_guJian_guide_KHD_IC204_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/lite/KaihongOS 5.0.1 Lite/L0-IC204/开鸿适配器 KHP-IC204 固件烧录指导书.pdf",
  doc_kaihong_lite_api_giude_ESP32_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/lite/KaihongOS 5.0.1 Lite/L0-IC204/KaihongOS 5.0.1 Lite API参考(KHP-IC204).pdf",

  doc_meta_platform_white_paper_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 超级设备管理平台白皮书.pdf", //超级设备平台白皮书
  doc_meta_simulator_white_paper_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 超级设备模拟器白皮书.pdf", //超级设备模拟器白皮书
  doc_meta_application_market_white_paper_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 开鸿行业应用市场白皮书.pdf", //超级设备应用市场白皮书
  doc_meta_rule_editor_white_paper_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 业务规则编辑器白皮书.pdf", //业务规则编辑器白皮书
  doc_meta_platform_operation_manual_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 超级设备管理平台操作手册.pdf", //超级设备平台操作手册
  doc_meta_simulator_operation_manual_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 超级设备模拟器操作手册.pdf", //超级设备模拟器操作手册
  doc_meta_application_market_operation_manual_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 开鸿行业应用市场操作手册.pdf", //超级设备应用市场操作手册
  doc_meta_rule_editor_operation_manual_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 业务规则编辑器操作手册.pdf", //业务规则编辑器操作手册
  doc_meta_api_gRPC_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 gRPC API参考.pdf", //gRPC API文档
  doc_meta_open_ability_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 OpenAbility参考.pdf", //OpenAbility参考
  doc_meta_rest_api_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 REST API参考.pdf", //REST API参考
  doc_meta_mqtt_api_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 MQTT订阅使用说明.pdf", //MQTT API参考
  doc_meta_websocket_api_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 WebSocket订阅使用说明.pdf", //WebSocket API参考
  doc_meta_data_serve_sdk_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 数据服务SDK使用说明.pdf", //SDK参考
  doc_meta_atomic_service_v501:
    "kaihong/prod/default/private/freedownload/v1.2/document/meta/KaihongOS Meta 5.0.1/KaihongOS Meta 5.0.1 原子化服务开发手册.pdf", //原子化服务开发指导书
};

const DOWNLOAD_LIMIT_MSG = "24小时内最多下载3次，请稍后再试";

async function runX86SaveBeforeDownload(
  pathTrackingKey: string,
  effectiveUserId?: string,
): Promise<boolean> {
  const saveResult = await saveDeveloperX86ImageDownloadWithRetry(
    buildX86ImageDownloadSavePayload(pathTrackingKey, {
      userId: effectiveUserId,
    }),
    {
      explicitUserId: effectiveUserId,
      clearIntentOnSuccess: true,
    },
  );
  await showX86DownloadQuotaModal(saveResult.message, saveResult.code);
  return saveResult.ok;
}

function buildLegacyPathFromDownloadUrl(rawUrl: string, linkUrl: string) {
  try {
    if (linkUrl) {
      const v3Idx = linkUrl.indexOf("v3");
      if (v3Idx >= 0) return linkUrl.slice(v3Idx);
    }
    const startV = "freedownload";
    const startIdx = rawUrl.indexOf(startV);
    const endIdx = rawUrl.indexOf("?");
    if (startIdx >= 0) {
      return rawUrl.slice(startIdx, endIdx >= 0 ? endIdx : undefined);
    }
  } catch (_e) {
    /* ignore */
  }
  return "";
}

function reportDownloadBaidu(
  legacyPath: string,
  trackMeta?: HandleBtnTrackMeta,
  bizIdFallback?: string,
) {
  const bizId = trackMeta?.bizId || bizIdFallback || "";
  const tabCode = trackMeta?.tabCode || "";
  if (tabCode && bizId) {
    trackBaiduPackageActionClick({
      tabCode,
      bizId,
      actionType: trackMeta?.actionType || "download",
      bizCode: trackMeta?.bizCode || "soft_package",
      channel: trackMeta?.channel || "pc",
      legacyDownloadPath: legacyPath || undefined,
    });
    return;
  }
  if (legacyPath) {
    trackBaiduLegacyDownloadPath(legacyPath);
  }
}

export const handleBtn = async (
  path: string,
  url?: string,
  userId?: string,
  trackMeta?: HandleBtnTrackMeta,
) => {
  try {
    let effectiveUserId = userId;
    if (!effectiveUserId && getServiceVal("Authorization")) {
      effectiveUserId =
        (await resolveCurrentUserId()) ?? undefined;
    }
    if (path) {
      const pathTrackingKey = path;
      const isX86Download = shouldReportDesktopDownloadAttraction(pathTrackingKey);
      const downloadId = `${effectiveUserId ?? "anon"}_${path}`;
      if (!isX86Download) {
        const downloadInfo = storageGetDownload(downloadId);
        if (downloadInfo) {
          const { count, ttl } = JSON.parse(downloadInfo);
          const now = new Date().getTime();
          if (now > ttl) {
            localStorage.removeItem(`download_${downloadId}`);
          } else if (count >= 3) {
            message.error(DOWNLOAD_LIMIT_MSG);
            return;
          }
        }
      }

      let linkUrl = ""; //存放链接地址
      if (RESOURCE_MAP[path]) {
        path = RESOURCE_MAP[path];
      }
      if (path.includes("https://")) {
        linkUrl = path;
        path = RESOURCE_MAP["image_kaihong_lite_khd_3863B"]; //提供一个默认接口  以方便接口通过
      }

      if (isX86Download) {
        const canDownload = await runX86SaveBeforeDownload(
          pathTrackingKey,
          effectiveUserId,
        );
        if (!canDownload) {
          return;
        }
        const decodePath = decodeURIComponent(path);
        const res: any = await getUrlByObjectKeyWithHit(decodePath);
        if (res.code === 200) {
          downloadFile(res.result.url);
        }
        return
      }

      const res: any = await getUrlByObjectKey(path);
      if (res.code === 200) {
        console.log("linkUrl =>", linkUrl);
        if (linkUrl !== "") {
          downloadFile(linkUrl);
        } else {
          // CDN 尚未启用：必须用接口返回的 OBS 原始预签名 URL（Host 与签名绑定，勿改域名）
          downloadFile(res.data);
          if (!isX86Download) {
            if (!storageGetDownload(downloadId)) {
              storageSaveDownload(downloadId, 1, new Date().getTime() + 60 * 60 * 24 * 1000);
            } else {
              const { count, ttl } = JSON.parse(storageGetDownload(downloadId) as string);
              storageSaveDownload(downloadId, count + 1, ttl);
            }
          }
        }

        const myIframe = document.getElementById(
          "hm_iframe"
        ) as HTMLIFrameElement;
        const startV = "freedownload";
        let iframeSrc =
          "download_hit#" +
          res.data.slice(res.data.indexOf(startV), res.data.indexOf("?"));
        if (linkUrl != "") {
          iframeSrc =
            "download_hit#" +
            linkUrl.slice(linkUrl.indexOf("v3"), res.data.indexOf("?"));
        }
        if (myIframe.src.includes("download_hit")) {
          //第二次要重新刷新iframe
          myIframe.src = iframeSrc;
          myIframe?.contentWindow?.location.reload();
        } else {
          //第一次不用刷新
          myIframe.src = iframeSrc;
        }
        const legacyPath = buildLegacyPathFromDownloadUrl(res.data || "", linkUrl);
        reportDownloadBaidu(legacyPath, trackMeta, pathTrackingKey);
      } else {
        window.message.error(res.msg || req_err);
      }
    } else if (url) {
      const urlTrackingKey = url;
      if (shouldReportDesktopDownloadAttraction(urlTrackingKey)) {
        const canDownload = await runX86SaveBeforeDownload(
          urlTrackingKey,
          effectiveUserId,
        );
        if (!canDownload) {
          return;
        }
      }
      if (RESOURCE_MAP[url]) {
        url = RESOURCE_MAP[url];
      }
      reportDownloadBaidu("", trackMeta, urlTrackingKey);
      window.open(url, "_blank");
    }
  } catch (error: any) {
    console.error(error);
  }
};

/**
 * 下载文件
 * @param url
 */
export const downloadFile = (url: string) => {
  console.log("downloadFile url =>", url);
  const a = document.createElement("a");
  a.href = url;
  a.click();
  a.remove();
};

/**
 * 百度统计pv 数据  由于没有开通事件分析 所以暂时用pv代替下载量
 * 下载量特定标识  #download_hit
 * @param url 
 */
export  const downloadHit=(url:string)=>{

    //上报百度统计
    window._hmt?.push(["_trackPageview", url]);
    console.log("downloadHit",url);
  };


const downloadQueue:Map<string,any> = new Map();//下载队列
const downloadIds:any[]=[];//下载id
const maxDownloadCount = 3;//最大同时下载数
let downloadingCount = 0;//当前下载数
let timer:any=null;
export const DOWNLOAD_HIT_PLACEMENT="#download_hit";

/**
 * 开始下载
 * @returns 
 */
const startDownload = () => {
  if(downloadQueue.size === 0) {
    console.log("downloadQueue is empty");
    return;
  }
  console.log("download start =>", downloadIds.length, downloadingCount);
  const maxLength=maxDownloadCount - downloadingCount;
  for (let i = 0; i < maxLength; i++) {
    const id = downloadIds[0];
    downloadIds.shift();
    if (id) {
      setTimeout(() => {
        const targetTask=downloadQueue.get(id);//获取任务
        if(targetTask){
          triggerDownload(targetTask);
          const hit_url=targetTask?.hit_url;
          if(hit_url){
            downloadHit(hit_url);
          }
        }
        
      }, 200);
      downloadingCount++;
      
       console.log("download start item =>", id,downloadingCount);
    }
  }
}
/**
 * 移除已下载任务
 * @param id 
 */
const removeDownload = (id:string) => {

  console.log("download remove =>",id);

    downloadQueue.delete(id);
    if (downloadingCount > 0) {
      downloadingCount--;
    }
    downloadingCount==0 && startDownload();
    console.log("download remove item =>",downloadingCount);
  
  
}
/**
 * 下载
 * @param item 
 */
const triggerDownload = (item:any) => {
  let iframe: any = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  // 轮询检查readyState
  const pollInterval = 500; // 每500毫秒检查一次
  const maxAttempts = 30; // 最大尝试次数，避免无限循环
  let attempts = 0;
  const removeIframe = () => {
    setTimeout(() => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
        iframe=null;
        removeDownload(item.id);

      }
    }, 200); // 稍作延迟再移除
  };
  const timer = setInterval(() => {
    attempts++;
    try {
      console.log("iframeDoc.readyState:", iframeDoc.readyState);
      // 判断文档是否加载完成
      if (
        iframeDoc.readyState === "complete" ||
        iframeDoc.readyState === "interactive"
      ) {
        clearInterval(timer);
        console.log("资源下载完成！");
        // 执行后续操作，例如移除iframe
        
          removeIframe();
        
      }
    } catch (e) {
      // 跨域情况下访问contentDocument会报错
      console.error("检测失败，可能由于跨域限制:", e);
      clearInterval(timer);
    }

    // 超过最大尝试次数后停止轮询
    if (attempts >= maxAttempts) {
      clearInterval(timer);
      console.log("轮询超时，无法确认下载状态。");
    }
  }, pollInterval);
  iframe.onload = (e:any) => {
  
    try {
      console.log("iframe加载成功:", e);
      const iframeDocument=iframe.contentDocument || iframe.contentWindow.document;
      console.log("iframeDoc:", iframeDocument.body);
    } catch (error) {
      //目标资源下载失败的情况下会返回一个xml文件 导致这个iframe重新加载
      //通过访问iframeDocument.body 判断是否下载失败 
      window.message.error((item?.name|| '')+"下载失败");
      console.error("下载失败:", error);
    }
  }
  iframe.onerror = (e:any) => {
    console.error("iframe加载失败:", e);
    clearInterval(timer);
    removeIframe();
  }
  // 设置src，开始下载
  iframe.src = item.url;
}

/**
 * 下载资源
 * @param resource 
 */
export const createDownloadResourceTask = async (task:{url:string,hit_url?:string,name?:string}) => {
  const isDownload= downloadingCount >= maxDownloadCount;
  const id= Date.now()+'-'+Math.random();
  downloadQueue.set(id,{...task,id});
  downloadIds.push(id);
  
  //限制 同时开启下载任务
  if(timer!=null){
    clearTimeout(timer);
  }
  timer=setTimeout(() => {
   !isDownload&& startDownload();
    timer=null;
    console.log("downloadResource ss=>",downloadQueue.size);
  }, 300);
    
  
};
